import React from "react";

import { selectTotalResouceAllocationEnabled } from "Reducers/featureFlags/featureFlags.selectors";
import ViewPortOnly from "src/organization/pages/project/environment/metrics/components/ViewPortOnly";
import { getDistanceToPreload } from "src/organization/pages/project/environment/metrics/utils/helper";
import { useAppSelector } from "Store/hooks";

import { TotalUsageProps } from "./TotalUsage";
import UsageView from "./UsageView";

type PageViewProps = {} & Omit<TotalUsageProps, "data" | "isLoading">;

const Page = (props: PageViewProps) => {
  const { timeframe, activities, setTimeFrame, setLastUpdated } = props;

  const totalUsageEnabled = useAppSelector(selectTotalResouceAllocationEnabled);
  const { rootMargin } = getDistanceToPreload(timeframe);

  return totalUsageEnabled ? (
    <ViewPortOnly option={{ rootMargin }}>
      <UsageView
        setLastUpdated={setLastUpdated}
        timeframe={timeframe}
        activities={activities}
        setTimeFrame={setTimeFrame}
      />
    </ViewPortOnly>
  ) : null;
};
export default Page;
